module.exports = __webpack_public_path__ + "img/es_icon_3.7a97f11c.png";